<template>
    <div class="ui-content dashboard">
        <div class="page-user approved modal-tab">
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab"
                :centered="centered"
                tabindex="-1"
            >
                <v-tabs-slider></v-tabs-slider>
                <!-- <v-tab :href="'#0'" :disabled="question.id">TC 2Q SA</v-tab>
                <v-tab :href="'#1'" :disabled="question.id">TC 3Q SA</v-tab> -->
                <v-tab v-for="(st, idx) in subTypes" tabindex="-1" :key="st.id" :href="'#' + idx" :disabled="question.id">{{st.value}}</v-tab>
            </v-tabs>
            <Comprehension2QSA
                v-if="tab==='0'"
                :tab="tab"
				:isEditable="isEditable"
                :question="question"
                :onNextQuestion="onNextQuestion"
                :showNextButton="showNextButton"
            />
            <Comprehension3QSA
                v-else-if="tab==='1'"
                :tab="tab"
				:isEditable="isEditable"
                :question="question"
                :onNextQuestion="onNextQuestion"
                :showNextButton="showNextButton"
            />
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";

import Comprehension2QSA from "@/components/QuestionType/Comprehensions/Comprehension2QSA.vue";
import Comprehension3QSA from "@/components/QuestionType/Comprehensions/Comprehension3QSA.vue";
export default {
    name: "Comprehensions",
    props: ["question", "onNextQuestion", "showNextButton",'isEditable'],
    components: {
        Comprehension2QSA,
        Comprehension3QSA
    },
    mounted() {
        this.getSubTypes();
        this.updateSubType();
    },
    data() {
        return {
            tab: "0",
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tabs: 2,
            subTypes: [],
        };
    },
    methods: {
        ...mapActions({
            getSubTypeList: "utilStore/getSubTypeList"
        }),
        getSubTypes() {
            let postData = {
                parent_id: this.question.questionType.id
            }
            this.getSubTypeList(postData).then((response) => {
                
                this.subTypes = response;                
            }).catch((err) => {
                
            });

        },

        updateSubType() {
            if (this.question.subtype === this.QUE_TYPES.TC_2Q_SA) {
                this.tab = "0";
            } else if (this.question.subtype === this.QUE_TYPES.TC_3Q_SA) {
                this.tab = "1";
            }
            if (!this.question.subtype) {
                this.question.subtype = this.QUE_TYPES.TC_2Q_SA;
            }
        }
    },
    watch: {
        question(val) {
            this.updateSubType();
        },
        tab(val) {
            if (val == 0) {
                this.question.subtype = this.QUE_TYPES.TC_2Q_SA;
            } else if (val == 1) {
                this.question.subtype = this.QUE_TYPES.TC_3Q_SA;
            }
        }
    }
};
</script>